/**
 * Normaliza strings para comparaciones (quitar espacios y minúsculas)
 */
export const normalizarRol = (valor = "") => String(valor).trim().toLowerCase();

/**
 * Capitaliza la primera letra de un texto
 */
export const capitalizar = (texto = "") =>
  texto ? texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase() : "";

/**
 * Retorna el nombre legible de un rol
 */
export const formatearNombreRol = (nombre = "") => {
  const rol = normalizarRol(nombre);
  if (rol === "admin") return "Administrador";
  if (rol === "director") return "Director";
  if (rol === "profesor") return "Profesor";
  return rol ? capitalizar(rol) : "-";
};

/**
 * Obtiene los apellidos concatenados del usuario
 */
export const getApellidos = (usuario) => {
  return [usuario?.apellidoPaterno, usuario?.apellidoMaterno]
    .filter((valor) => valor && valor !== "-")
    .join(" ")
    .trim() || usuario?.apellidos || usuario?.apellido || "-";
};

/**
 * Formatea fechas a formato local peruano (DD/MM/YYYY HH:mm:ss)
 */
export const formatearFechaHora = (valor) => {
  if (!valor) return "-";
  const fecha = new Date(valor);
  if (Number.isNaN(fecha.getTime())) return valor;

  return fecha.toLocaleString('es-PE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

/**
 * Extrae los roles únicos de los vínculos del usuario
 */
export const obtenerRolesUsuario = (usuario) => {
  const vinculos = Array.isArray(usuario?.vinculos) ? usuario.vinculos : [];
  const vistos = new Set();
  const rolesUnicos = [];

  vinculos.forEach((v) => {
    const nombre = v?.rol?.nombre;
    if (nombre) {
      const key = normalizarRol(nombre);
      if (!vistos.has(key)) {
        vistos.add(key);
        rolesUnicos.push(formatearNombreRol(nombre));
      }
    }
  });

  if (rolesUnicos.length === 0 && usuario?.is_admin) return ["Administrador"];
  return rolesUnicos;
};

/**
 * Extrae los nombres de instituciones únicas del usuario
 */
export const obtenerInstitucionesUsuario = (usuario) => {
  const vinculos = Array.isArray(usuario?.vinculos) ? usuario.vinculos : [];
  const vistos = new Set();
  const instituciones = [];

  vinculos.forEach((v) => {
    const nombre = v?.institucion?.nombre || "";
    const nivel_modalidad = v?.institucion?.nivel_modalidad || "";
    const nombre_nivel=  `${nombre} (${nivel_modalidad})`
    if (nombre && !vistos.has(nombre)) {
      vistos.add(nombre);
      instituciones.push(nombre_nivel);
    }
  });

  return instituciones;
};